export default __webpack_public_path__ + "static/mid-d0d5d50b33015a05c00af6a487c046c7.png";